export default __webpack_public_path__ + "static/media/amazon.f5f67f13.svg";